  
        <span *ngIf="errorMessage !== null" class="control-error-message show">
            
            <span #customMessageContent><ng-content></ng-content></span>
            <span *ngIf="!customMessageContent.innerHTML.trim()" translate>{{errorMessage}}</span>
        </span>